import React from 'react';
import { Icon, IconType, Theme } from '@routific/hive';

const NextIcon: React.FC = () => {
  return <Icon icon={IconType.Forward} style={{ color: Theme.Colors.primary5 }} />;
};

export default NextIcon;
